import { AddressDTO, getCountryNameByCode } from '@ringo/shared'
import { useTranslation } from '../../useTranslation'

interface AddressPreviewProps {
    address: AddressDTO
}

const AddressPreview = ({ address }: AddressPreviewProps) => {
    const { t } = useTranslation()
    return (
        <div>
            <span className="block">{address.companyName}</span>
            {(address.firstName || address.lastName) && <span className="block">{address.firstName + ' ' + address.lastName}</span>}
            <span className="block mt-6 max-tablet:mt-5">{[address.street, address.houseNumber].filter((x) => !!x).join(' ')}</span>
            <span className="block">{address.postalCode + ' ' + address.city}</span>
            <span className="block">{getCountryNameByCode(address.country as any, t)}</span>
        </div>
    )
}

export default AddressPreview
